import { execute, INSERT, SELECT } from "@/utils/database_module";
import { Chat, ChatMessage, Conflict, User } from "@/utils/types";

const chats = {
  getAll: async () => {
    // 1. Get the latest message per user from the chat_messages table
    const openedChats = (await execute(`
    SELECT * FROM chat_messages cm
    WHERE (cm.user_id, cm.date) IN (
      SELECT user_id, MAX(date) AS max_date
      FROM chat_messages
      GROUP BY user_id
    )
    GROUP BY chat_id
    ORDER BY cm.date DESC
  `)) as ChatMessage[];

    // 2. Get all conflicts, with the conflict type and linked user_id through orders
    const conflicts = (await execute(`
    SELECT 
      conflicts.type, 
      conflicts.id AS conflict_id, 
      users.id AS user_id  
    FROM conflicts 
    JOIN orders ON conflicts.order_id = orders.id 
    JOIN users ON users.id = orders.user_id
  `)) as Conflict[];

    // 3. Fetch all users with selected fields
    const users = (await SELECT("users", {
      columns: [
        "first_name",
        "last_name",
        "profile_pic",
        "email",
        "id",
        "role",
        "token",
      ],
      isIndexed: true,
    })) as any[];

    // 4. Attach conflicts to each user
    for (const user of users) {
      user.conflicts = conflicts.filter((c: any) => c.user_id === user.id);
    }

    // 5. Attach user info to each chat message
    for (const chat of openedChats) {
      chat.user = users.find((u) => u.id === chat.user_id);

      // If user not found (possibly deleted or missing), assign default fallback
      if (!chat.user) {
        chat.user = {
          first_name: "unknown",
          id: chat.user_id,
        };
      }
    }

    // 6. Return both opened chats and all users as 'allChats'
    return {
      openedChats,
      allChats: users,
    };
  },

  getOne: async (id: number, isUserLoggedIn?: boolean) => {
    const messages = (await SELECT(`chat_messages`, {
      conditions: [{ column: "chat_id", operator: "=", value: id }],
      order: "`chat_messages`.`date` DESC",
    })) as unknown as ChatMessage[];
    if (!isUserLoggedIn) return messages;

    const users = (await SELECT(`users`, {
      columns: [
        "first_name",
        "last_name",
        "profile_pic",
        "email",
        "id",
        "role",
        "token",
      ],
    })) as User[];
    for (const message of messages) {
      message.user = users.find((u) => u.id == message.sender_id);
    }
    return messages;
  },

  insert: async (data: {
    chat_id: string;
    user_id: any;
    msg: string;
    sender_id: any;
    image: string;
    isConflict: 0 | 1;
  }) => {
    const message = {
      chat_id: data?.chat_id,
      user_id: data?.user_id ?? data?.chat_id,
      message: data?.msg,
      sender_id: data?.sender_id,
      image: data?.image,
      is_conflict: data?.isConflict,
    };
    return await INSERT("chat_messages", message);
  },
};

export default chats;
